export default __webpack_public_path__ + "static/media/focus.7c784136.png";